import React from 'react';

import PropTypes from 'prop-types';

function ArrowIcon2({ width = 14, height = 12, color = '#1B1C19', ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 14 12"
      fill="none"
      {...rest}
    >
      <path
        d="M0 6C0 6.15912 0.0614557 6.31172 0.170848 6.42424C0.280241 6.53676 0.42861 6.59997 0.583314 6.59997H12.0083L7.7537 10.9752C7.69951 11.031 7.65652 11.0971 7.62719 11.17C7.59786 11.2428 7.58276 11.3209 7.58276 11.3997C7.58276 11.4785 7.59786 11.5566 7.62719 11.6294C7.65652 11.7023 7.69951 11.7684 7.7537 11.8242C7.8079 11.8799 7.87224 11.9241 7.94305 11.9543C8.01386 11.9845 8.08975 12 8.1664 12C8.24304 12 8.31894 11.9845 8.38975 11.9543C8.46056 11.9241 8.5249 11.8799 8.57909 11.8242L13.8289 6.42448C13.8832 6.36876 13.9262 6.30259 13.9555 6.22975C13.9849 6.15692 14 6.07884 14 6C14 5.92115 13.9849 5.84308 13.9555 5.77025C13.9262 5.69741 13.8832 5.63124 13.8289 5.57552L8.57909 0.175824C8.46964 0.0632457 8.32119 -1.1862e-09 8.1664 0C8.01161 1.1862e-09 7.86316 0.0632457 7.7537 0.175824C7.64425 0.288402 7.58276 0.441091 7.58276 0.6003C7.58276 0.75951 7.64425 0.912198 7.7537 1.02478L12.0083 5.40003H0.583314C0.42861 5.40003 0.280241 5.46324 0.170848 5.57576C0.0614557 5.68827 0 5.84088 0 6Z"
        fill={color}
      />
    </svg>
  );
}

ArrowIcon2.propTypes = {
  color: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
};

export default ArrowIcon2;
